import API from '../../api';

// Servizio condiviso per le campagne attive (GET /active_campaign).
// De-duplica la costruzione dell'URL (campaign_type solo se ≠ PD) e il recupero combinato
// PD+GD finora ripetuti in RegistrationPage, ProfilePage e cardsTab.

/**
 * Campagna attiva per tipo. Per 'PD' (o vuoto) nessun query param; altrimenti ?campaign_type=TIPO.
 *
 * @param {string} [campaignType='PD']
 * @returns {Promise<object|null>} il corpo della campagna (response.data)
 */
export async function getActiveCampaign(campaignType = 'PD') {
  const query = campaignType && campaignType !== 'PD' ? `?campaign_type=${campaignType}` : '';
  const res = await API.get(`/active_campaign${query}`);
  return res.data;
}

/**
 * Recupera in parallelo la campagna PD e la campagna GD attive, in modo resiliente:
 * se una delle due fallisce, il relativo valore è null (allSettled).
 *
 * @returns {Promise<{pd: object|null, gd: object|null}>}
 */
export async function getActivePdGdCampaigns() {
  const [pdRes, gdRes] = await Promise.allSettled([
    API.get('/active_campaign'),
    API.get('/active_campaign?campaign_type=GD'),
  ]);
  return {
    pd: pdRes.status === 'fulfilled' ? pdRes.value.data : null,
    gd: gdRes.status === 'fulfilled' ? gdRes.value.data : null,
  };
}
